import { useState } from "react";
import { Box, Typography, Button, Stack, LinearProgress } from "@mui/material";
import QuestionView from "./QuestionView";
import { api } from "../api";

export default function QuizPlayer({ quiz, onFinish }) {
  const total = quiz.questions.length;

  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [answered, setAnswered] = useState(false);

  const currentQuestion = quiz.questions[currentIndex];
  const isLastQuestion = currentIndex === total - 1;

  const handleSend = () => {
    setAnswered(true);
  };

  const handleNext = async (payload) => {
    const nextAnswers = [...answers];
    nextAnswers[currentIndex] = payload;
    setAnswers(nextAnswers);


    if (!isLastQuestion) {
      setCurrentIndex((i) => i + 1);
      setAnswered(false);
    } else {

      await api.submitQuiz({
        quizId: quiz.id,
        answers: nextAnswers,
      });

      onFinish?.();
    }
  };

  return (
    <Box sx={{ maxWidth: 800, mx: "auto", mt: 4 }}>
      <Stack spacing={1} sx={{ mb: 3 }}>
        <Typography variant="body2" color="text.secondary">
          Question {currentIndex + 1} / {total}
        </Typography>
        <LinearProgress
          variant="determinate"
          value={((currentIndex + 1) / total) * 100}
        />
      </Stack>

      <QuestionView
        key={currentQuestion.id}
        question={currentQuestion}
        answered={answered}
        isLastQuestion={isLastQuestion}
        onSend={handleSend}
        onNext={handleNext}
      />
    </Box>
  );
}
